import { useContext } from "react";
import { AttachmentsIndexContextValue } from "./types";
import { AttachmentsIndexContext } from "./contexts";

/* ===========================================================================
 * HOOK: useAttachmentsIndexContext
 * ===========================================================================
 */

/**
 * @function useAttachmentsIndexContext
 * Retrieves the value of the AttachmentsIndexContext.
 *
 * This Hook ensures that the calling component is wrapped inside
 * an AttachmentIndexProvider. Attempting to use it outside of its
 * provider will result in an explicit contextual usage error.
 *
 * @returns {AttachmentsIndexContextValue} The current attachments index context value.
 * @throws {Error} If called outside of an AttachmentIndexProvider.
 */
export const useAttachmentsIndexContext = (): AttachmentsIndexContextValue => {
  const context = useContext(AttachmentsIndexContext);

  if (!context) {
    throw new Error(
      "useAttachmentsIndexContext must be used within an AttachmentIndexProvider",
    );
  }

  return context;
};
